module.exports = __webpack_public_path__ + "static/media/cb.901ed82a.webp";